import * as React from 'react';
import orderBy from 'lodash/orderBy';
import { ComparisonWidgetSectionView } from 'components/Widgets/Comparison/ComparisonWidget';
import { TopSpendItems } from 'components/Tables/TopSpendItems';
import {
  SectionWrapper,
  HeaderLabel,
  TopDataContent,
  TableWidgets,
  TableContainer,
  HeaderTop,
} from './Analysis.styles';
import { Container as ComparisonWidgetContainer } from 'components/Widgets/Widgets.styles';
import { ApiContext } from 'context/ApiContext';
import { ICurrencyFormat, ITopItemsResponse } from 'utils/types';
import { EXPORT_OPTIONS } from 'utils/constants';
import {
  getFormattedPercentage,
  getDateLabels,
  getPeriodLabel,
} from 'utils/format';
import { ApSimpleDropdown } from '@alixpartners/ui-components';

const TopSpendItemsView = ({
  downloadSpendTopThirdPartyData,
  format,
  showSuccessNotification,
  topItems,
}: {
  downloadSpendTopThirdPartyData: () => Promise<any>;
  format: ICurrencyFormat;
  showSuccessNotification: () => void;
  topItems: ITopItemsResponse;
}) => {
  if (!topItems) {
    return null;
  }
  const rowData = orderBy(topItems.items, 'total', 'desc').map((item) => {
    return {
      title: item.spendItem,
      vendor: item.vendor,
      serviceTower: item.serviceTower,
      expenseType: item.expenseType,
      totalCurrYear: item.total,
      totalPrevYear: item.previousTotal,
      totalChange: item.change,
    };
  });
  const columnDateLabels = getDateLabels(
    topItems.range,
    topItems.comparisonRange
  );
  return (
    <SectionWrapper>
      <HeaderTop>
        <HeaderLabel>Top Third party spend items</HeaderLabel>
        <ApSimpleDropdown
          iconName="outline_save_alt"
          onChange={(opt: any) => {
            if (opt.value === 'xlsx') {
              downloadSpendTopThirdPartyData().then(showSuccessNotification);
            }
          }}
          options={[EXPORT_OPTIONS[1]]}
          label="Export"
        />
      </HeaderTop>
      <TopDataContent>
        <TableContainer>
          <TopSpendItems
            rowData={rowData}
            columnDateLabels={columnDateLabels}
            format={format}
          />
        </TableContainer>
        <TableWidgets>
          <ComparisonWidgetContainer>
            <ComparisonWidgetSectionView
              title="YEAR ON YEAR COMPARISON"
              currentPeriod="% of total IT spend"
              currentValue={getFormattedPercentage(
                topItems.widget.percentageOfTotal,
                format
              )}
              previousPeriod={`${getPeriodLabel(
                topItems.comparisonRange
              )} equivalent`}
              previousValue={getFormattedPercentage(
                topItems.widget.previousPercentageOfTotal,
                format
              )}
              netChange={topItems.widget.change}
              variance={getFormattedPercentage(
                topItems.widget.variance,
                format
              )}
              format={format}
            />
          </ComparisonWidgetContainer>
        </TableWidgets>
      </TopDataContent>
    </SectionWrapper>
  );
};

export default (props: any) => (
  <ApiContext.Consumer>
    {({ format }) => <TopSpendItemsView {...props} format={format} />}
  </ApiContext.Consumer>
);
